import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import s from './TextList.scss';

const renderList = data => (
  <ul className={s.timeline_listing}>
    {data.map(item => (typeof item === 'string' ? <li>{item}</li> : ''))}
  </ul>
);

const renderData = (item,itemIndex) => {
  if (typeof item === 'string' && item === '<br/>') {
    return <br />;
  } else if (typeof item === 'string') {
    return <Text content={item} wrapInPara={false}  index={itemIndex}/>;
  } else if (item instanceof Array) {
    return renderList(item);
  } else if (typeof item === 'object') {
    return (
      <Text
      index={itemIndex}
        overridelink={item.link}
        content={item.linkText}
        wrapInPara={false}
        //data-newga={`hyperlink_clicked#update_${itemIndex}`}
      />
    );
  }
  return null;
};

const TextList = props => {
  const { data = {}, itemIndex } = props;
  const description = data.emcontent || data.smalldesc || data.smallDesc || '';
  
  if (!data.smalldescv2 && typeof description === 'string') {
    return <Text index={itemIndex} content={description} />;
  } else if (!(data.smalldescv2 instanceof Array)) {
    return null;
  }
  return <p >{data.smalldescv2.map(item => renderData(item, itemIndex))}</p>;
};

TextList.propTypes = {
  data: PropTypes.shape([]).isRequired,
  itemIndex: PropTypes.string.isRequired,
};

TextList.defaultProps = {};

export default React.memo(TextList);
